import * as Sentry from '@sentry/react';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import toaster from 'react-hot-toast';
import { AddPayrocTerminalAccountPayload } from 'api/admin/stores/addPayrocTerminalAccount';
import { addPayrocTerminalAccount } from 'api/admin/stores/addPayrocTerminalAccount';

export const useAddPayrocTerminal = () => {
  return useMutation<unknown, AxiosError<{ error: string }>, AddPayrocTerminalAccountPayload>({
    mutationFn: async ({ terminalId, storeId, payrocMerchantAccountId }) => {
      return addPayrocTerminalAccount({
        terminalId,
        storeId,
        payrocMerchantAccountId,
      });
    },
    onSuccess: async () => {
      toaster('Payroc Terminal Account has been added', {
        icon: '✅',
      });
    },
    onError: (error) => {
      Sentry.captureException(error);
      toaster(error?.response?.data?.error ?? 'An error occurred while adding terminal account', {
        icon: '❌',
      });
      return error;
    },
  });
};
